export default __webpack_public_path__ + "static/2.2_EN-bb7245d9c6498c5bb430c840c6a5efae.webp";